export default "__VITE_ASSET__a49becbf__"